export default __webpack_public_path__ + "static/media/rewards.c00519b5.png";